/**
 * @fileoverview Agent definition for the plot-synopsis-extractor-v3 primitive.
 *
 * This agent creates a condensed synopsis from imported content,
 * targeting approximately 3% of the original length with a minimum of 1000 tokens.
 *
 * @category import.story.synopsis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'plot-synopsis-extractor-v3',
  kind: 'primitive',
  name: 'Synopsis Extractor',
  description: 'Creates a condensed synopsis from imported content, approximately 3% of original length (minimum 1000 tokens).',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    lastUpdated: '2026-02',
    taxonomyPath: 'import.story.synopsis',
    usedBy: [],
    relatedAgents: ['story-dna-extractor-v2', 'plot-extractor-v2', 'storyline-extraction-pipeline-v1'],
  },
};
